class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');

        this.btnOpenMenu = this.header.querySelector('.btnOpenMenu');
        this.menu = this.header.querySelector('.header-menu');

        this.mobileMenu();
        this.searchModal();

        this.initGoToTop();
    }

    mobileMenu() {
        const desktopMedia = window.matchMedia('(min-width: 1280px)');

        const close = (restoreFocus = true) => {
            this.header.classList.remove('active');
            this.btnOpenMenu.classList.remove('active');
            this.menu.classList.remove('active');
            this.btnOpenMenu.setAttribute('aria-expanded', 'false');

            if (!desktopMedia.matches) this.menu.setAttribute('inert', '');
            if (restoreFocus) this.btnOpenMenu.focus();
        };

        const open = () => {
            this.menu.removeAttribute('inert');
            this.header.classList.add('active');
            this.btnOpenMenu.classList.add('active');
            this.menu.classList.add('active');
            this.btnOpenMenu.setAttribute('aria-expanded', 'true');
            this.menu.querySelector('a, button')?.focus();
        };

        const syncViewport = () => {
            if (desktopMedia.matches) {
                this.menu.removeAttribute('inert');
                close(false);
                this.menu.removeAttribute('inert');
            } else if (!this.header.classList.contains('active')) {
                this.menu.setAttribute('inert', '');
            }
        };

        this.btnOpenMenu.addEventListener('click', () => {
            this.header.classList.contains('active') ? close() : open();
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.header.classList.contains('active')) close();
        });

        desktopMedia.addEventListener('change', syncViewport);
        syncViewport();
    }

    initGoToTop() {
        this.btnTop = document.querySelector('.btnGoToTop');

        this.btnTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    searchModal() {
        const btns = document.querySelectorAll('.btnActionSearch');
        const modal = document.querySelector('.modal-busca');
        if (!modal) return;

        const input = modal.querySelector('input');
        let lastFocusedElement = null;
        let focusTimer = null;

        const open = (trigger) => {
            lastFocusedElement = trigger || document.activeElement;
            modal.classList.add('active');
            modal.removeAttribute('aria-hidden');
            modal.removeAttribute('inert');

            clearTimeout(focusTimer);
            focusTimer = setTimeout(() => input?.focus(), 120);
        };

        const close = () => {
            clearTimeout(focusTimer);
            modal.classList.remove('active');
            modal.setAttribute('aria-hidden', 'true');
            modal.setAttribute('inert', '');

            if (lastFocusedElement && document.contains(lastFocusedElement)) {
                lastFocusedElement.focus();
            }
        };

        btns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                open(btn);
            });
        });

        const closeBtn = modal.querySelector('.btnCloseSearch');
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                close();
            });
        }

        modal.addEventListener('click', (e) => {
            if (e.target === modal) close();
            e.stopPropagation();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                close();
            }
        });
    }
}

new Header();
